import React, { Component } from "react";
// Component
import BootstrapTable from "react-bootstrap-table-next";
import Modal from "react-responsive-modal";
import {
  Button,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link, Redirect } from "react-router-dom";
import ModalGenerateForm from "./modal/surat-generate-form";

// koneksi
import API_URL, { Post, Get, Delete, GetAwait} from "../../function/Koneksi";

// Preview Surat
import Iframe from 'react-iframe'
import { GetJenisSurat } from '../../function/jenis-surat';
import { getList } from '../../function/get-data';

// css files
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

const frmSurat = {
  uuid: '',
  id_jenis: '',
}

class BasicTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pagination: [],
      status: {
        form: false,
        btnForm: false,
        btnAksi: [],
        dataPenduduk: "none",
        dataPenduduk2: "none",
        frmPreviewDraft: false,
        frmDetailPengajuan: false,
        jenis_form: '',
      },
      awal: "",
      sebelum: "",
      hal: [],
      setelah: "",
      akhir: "",
      dt: frmSurat,
      loading: false,
      loadingPreview: false,
      tmplistPenduduk: null,
      tmplistPenduduk2: null,
      judul: this.props.location.state ? "Tambah "+this.props.location.state.nama_surat : '',
      dataSurat: this.props.location.state,
      shdk: "",
      // ============ Select 2 ==============
      frmNik: [],
      frmNik2: [],
      frmShdkLabel:[],
      frmListPerangkat: [],
      nikStat: null,
      nik2Stat: null,
      formPasangan: "none",
      // ===================================
      // ============ Alert ==============
      alert: null,
      show: false,
      basicTitle: "",
      basicType: "default",
      pesanAlert: "",
      successAlert: false,
      // ===================================
      
      // Preview surat
			get_data_surat:[],
			get_jenis_surat: "",

      field_inputan:[],
      formSelect:null,
      formSelectPenduduk:null,
      detailStatus: [],
      dinamisTemplate: null,
      pemohonStatus: null,
      manualStatus: null,
      status_data:"create",

      // Cari Data
      dataCari: {
				q: '',
			},

      // Tanda Tangan
      listPerangkatDesa: [],
      accButtonPerangkatDesa: [],
      ttdSelected: [],
    };
  }
  
  // ================== Sweet Alert ==================
  closeAlert = () => {
    this.setState({
      show: false,
      successAlert: false
    });
  };

  onRecieveInput = value => {
    this.setState({
      alert: (
        <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
          You wrote: {value}
        </SweetAlert>
      )
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

// ################################################################################################

  // FETCH DATA SURAT
  fetch = (params = {}) => {
    this.setState({ loading: true })
    let link = "";
    
    let route_fetch = this.props.location.state.route_ws;
    if(this.props.location.state.jenis_layanan === "Internal"){
      route_fetch = this.props.location.state.route_ws +'?id_jenis='

      if (params.page) {
        switch (params.page) {
          case ">>":
            link =
              "&page=" +
              Math.ceil(
                this.state.pagination.total / this.state.pagination.per_page
              );
            break;
          case ">":
            link = "&page=" + (parseInt(this.state.pagination.current_page) + 1);
            break;
          case "<":
            link = "&page=" + (parseInt(this.state.pagination.current_page) - 1);
            break;
          case "<<":
            link = "&page=1";
            break;
          default:
            link = "&page=" + params.page;
            break;
        }
      }
    }
    else{
      if (params.page) {
        switch (params.page) {
          case ">>":
            link =
              "?page=" +
              Math.ceil(
                this.state.pagination.total / this.state.pagination.per_page
              );
            break;
          case ">":
            link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
            break;
          case "<":
            link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
            break;
          case "<<":
            link = "?page=1";
            break;
          default:
            link = "?page=" + params.page;
            break;
        }
      }
    }

    Post(route_fetch + this.props.location.state.uuid + link, null, this.state.dataCari, dtkat => {

        if(dtkat.data.results){
          this.setState({ data: dtkat.data.results.data, pagination: dtkat.data.results, loading: false });
          this.pagination(dtkat.data.results); 

        }
    });
  };

  // PAGINATION SURAT
  pagination = data => {
    let awal = "";
    let hal = [];
    let sebelum = "";
    let setelah = "";
    let akhir = "";
    if (data.total > 0) {
      let start = 1;
      let end = 5;
      let n = 0;
      let p = 0;
      if (data.current_page <= 3) {
        start = 1;
        end = 5;
        if (data.last_page > data.current_page) {
          n = data.current_page + 1;
        }
      } else {
        p = data.current_page - 1;
        n = data.current_page + 1;
        start = data.current_page - 2;
        end = data.current_page + 2;
      }
      if (end >= data.last_page - 2) {
        p = data.current_page - 1;
        if (start >= 5) {
          start = data.last_page - 4;
        }
        end = data.last_page;
      }

      for (let i = start; i <= end; i++) {
        let warna = "primary-custom";
        if (i === data.current_page) {
          warna = "danger";
        }
        hal.push(
          <a
            href={() => false}
            onClick={() => this.fetch({ page: i })}
            className={
              "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            }
          >
            {i}
          </a>
        );
      }
      if (p > 0) {
        sebelum = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: p })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {"<"}
          </a>
        );
      }
      if (n > 0) {
        setelah = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: n })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {">"}
          </a>
        );
      }
      awal = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: 1 })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {"<<"}
        </a>
      );
      akhir = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: data.last_page })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {">>"}
        </a>
      );
    }
    this.setState({ awal, sebelum, hal, setelah, akhir });
  };

  // TOMBOL AKSI SURAT
  tombolAksi = (cell, row) => {
    let btnAksi = false;
    let status = "";
    let btnCetak = true;
    let route_download = '';
    if(this.props.location.state.jenis_layanan === "Internal"){
      if (row.status_surat.toLowerCase() === "selesai") {
        btnAksi = true
      }

      route_download = row.data_jenis.route_surat.substring(1)
    }
    else{
      row.data_status.forEach(dt => {
        status = dt.status;
      });
      if (status === "Diajukan") {
        // btnCetak = true;
        btnAksi = true;
        // btnApproval = true;
      } else {
        btnAksi = true;
        // btnApproval = true;
        if (status === "Ditolak") {
          // btnCetak = true;
        } else if (status === "Disetujui") {
          btnAksi = false;
          // btnCetak = true;
          // btnApproval = false;
        } else if ((status === "Menunggu Penerbitan") | (status === "Selesai")) {
          // btnAksi = false;
          // btnCetak = false;
          // btnApproval = false;
        } else {
          // btnCetak = true;
        }
      }
    }
    return (
      <>
        <Button
          size="xs"
          color="info"
          className="btn-icon mr-1"
          onClick={(e) => {
            this.setState({
              status:{
                ...this.state.status,
                frmDetailPengajuan: true,
              },
              status_data:'detail',
            })
            this.ubahData(row.uuid)
          }}
        >
          <i className="fa fa-eye"></i>
        </Button>
        {
          this.props.location.state.jenis_layanan === "Internal"
          ?
            <>
              <Button
                size="xs"
                color="warning"
                className="btn-icon mr-1"
                onClick={(e) => {
                  this.setState({
                    status_data:'update',
                  })
                  this.ubahData(row.uuid)
                }}
                disabled={btnAksi}
              >
                <i className="fa fa-pencil"></i>
              </Button>
              {btnCetak ? (
                <Button
                  size="xs"
                  title="Cetak Surat"
                  color="success"
                  className="btn-icon"
                  onClick={(e) => {
                    let linkDownload = API_URL + route_download + row.uuid + '?status_barcode=tidak'

                    this.setState({ loading: true })

                    this.downloadSurat(linkDownload, row)
                  }}
                >
                  <i className="fa fa-print" style={{ color: 'white' }} />
                </Button>
              ) : ''}
            </>
          : 
            <>
              <Button
                size="xs"
                color="warning"
                className="btn-icon"
                onClick={(e) => {
                  this.setState({
                    status_data:'update',
                  })
                  this.ubahData(row.uuid)
                }}
                disabled={btnAksi}
              >
                <i className="fa fa-pencil"></i>
              </Button>{" "}
            </>
        }
      </>
    );
  };

  downloadSurat = (linkDownload, data_surat) => {
		let token = sessionStorage.getItem("access_token")
			? sessionStorage.getItem("access_token")
			: "public";
    
    let dataSuratParsed = JSON.parse(data_surat.detail_surat)

		fetch(linkDownload, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/pdf',
				'Authorization': 'Bearer ' + token,
			},
		})
		.then((response) => {
			if (response.status === 200) {
				return response.blob()
			}
			this.setState({
				loading: false,
				show: true,
				basicType: 'danger',
				basicTitle: 'Data Penerbitan Surat',
				pesanAlert: 'Gagal download surat'
			});
			throw new Error('Something went wrong');
		})
		.then((blob) => {
			// Create blob link to download
			const url = window.URL.createObjectURL(
				new Blob([blob]),
			);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute(
				'download',
				`${data_surat.data_jenis.nama}.pdf`,
				// `${data_surat.data_jenis.nama} (${dataSuratParsed.nama_pegawai}).pdf`,
			);

			// Append to html link element page
			document.body.appendChild(link);

			// Start download
			link.click();

			// Clean up and remove the link
			link.parentNode.removeChild(link);

      // Refresh
      this.fetch({ page: null, where: [] });
			this.setState({
				loading: false,
			})
		})
		.catch((e) => {
			// console.log(e);
		})
		;
	}
  
  // TAMBAH DATA SURAT
  // tambahData = e => {
  //   this.setState({ loadingPreview: true });
  //   this.setFieldInputan()
  //   let detailStatus = {}
  //   let dinamisTemplate = {}
  //   let manualStatus = {}
  //   let allData = frmSurat;

  //   Object.keys(this.state.field_inputan).forEach((data_level1) => {
  //     // console.log('this.state.field_inputan[data_level1]')
  //     // console.log(data_level1)
  //     // console.log(this.state.field_inputan[data_level1])
  //     if(this.state.field_inputan[data_level1]){
  //       if(Array.isArray(this.state.field_inputan[data_level1][0])){
          
  //         if(this.state.field_inputan[data_level1][0][0][0].type === 'nik'){
  //           detailStatus = {
  //             ...detailStatus,
  //             [data_level1]: {
  //               ...detailStatus[data_level1],
  //               0: false,
  //             }
  //           }

  //           manualStatus[data_level1] = {
  //             ...manualStatus[data_level1],
  //             [0]: null
  //           }
  //         }
  //         else if(this.state.field_inputan[data_level1][0][0][0].type === 'perangkat'){
  //           detailStatus = {
  //             ...detailStatus,
  //             [data_level1]: {
  //               ...detailStatus[data_level1],
  //               0: false,
  //             }
  //           }

  //           manualStatus[data_level1] = {
  //             ...manualStatus[data_level1],
  //             [0]: true
  //           }
  //         }
  //         else{
  //           detailStatus = {
  //             ...detailStatus,
  //             [data_level1]: {
  //               ...detailStatus[data_level1],
  //               0: true,
  //             }
  //           }
            
  //           manualStatus[data_level1] = {
  //             ...manualStatus[data_level1],
  //             [0]: true
  //           }
  //         }

  //         allData[data_level1] = [[]]
  //         dinamisTemplate = {
  //           ...dinamisTemplate,
  //           [data_level1]: this.state.field_inputan[data_level1][0],
  //         }
  //       }
  //       else{
          
  //         // Jika array pertama type nik, status false
  //         if(this.state.field_inputan[data_level1][0].type === 'nik'){
  //           detailStatus = {
  //             ...detailStatus,
  //             [data_level1]: false,
  //           }

  //           manualStatus[data_level1] = null
  //         }
  //         // Jika array pertama type nik, status false
  //         else if(this.state.field_inputan[data_level1][0].type === 'perangkat'){
  //           detailStatus = {
  //             ...detailStatus,
  //             [data_level1]: false,
  //           }

  //           manualStatus[data_level1] = true
  //         }
  //         // Jika array pertama selain nik, status true
  //         else{
  //           detailStatus = {
  //             ...detailStatus,
  //             [data_level1]: true,
  //           }

  //           manualStatus[data_level1] = true
  //         }
  //         allData[data_level1] = []
  //         dinamisTemplate = {
  //           ...dinamisTemplate,
  //           [data_level1]: null,
  //         }
  //       }
  //     }
  //   })

  //   dinamisTemplate = {
  //     ...dinamisTemplate,
  //     nik: this.state.frmNik,
  //   }

  //   if(this.props.location.state.jenis_layanan === "Internal"){
  //     dinamisTemplate = {
  //       ...dinamisTemplate,
  //       perangkat: this.state.frmListPerangkat
  //     }
  //     allData['data_penandatangan'] = [
  //       {
  //         key: 'uuid',
  //         value: '',
  //         pemohon: false,
  //       },
  //       {
  //         key: 'jabatan',
  //         value: '',
  //         pemohon: false,
  //       },
  //       {
  //         key: 'nama',
  //         value: '',
  //         pemohon: false,
  //       },
  //       {
  //         key: 'nip',
  //         value: '',
  //         pemohon: false,
  //       },
  //       {
  //         key: 'golongan',
  //         value: '',
  //         pemohon: false,
  //       },
  //     ]
  //   }

  //   this.setState({
  //     status: {
  //       ...this.state.status,
  //       dataPenduduk: "none",
  //       dataPenduduk2: "none",
  //       // form: true
  //     },
  //     dt: allData,
  //     detailStatus: detailStatus,
  //     dinamisTemplate: dinamisTemplate,
  //     manualStatus: manualStatus,
  //     nikStat: null,
  //     nik2Stat: null,
  //     status_data:"create",
  //   });

  //   setTimeout(function () {
  //     this.setState({
  //       loadingPreview: false,
  //       status: {
  //         ...this.state.status,
  //         form: true,
  //       },
  //     })
  //   }.bind(this),3000)
  // };

  tambahData = async (e) => {
    this.setState({ loadingPreview: true });
    
    // Set initial data
    this.setFieldInputan();
  
    let detailStatus = {};
    let dinamisTemplate = {};
    let manualStatus = {};
    let allData = frmSurat;
  
    // Proses data inputan
    await Promise.all(
      Object.keys(this.state.field_inputan).map(async (data_level1) => {
        const inputanLevel1 = this.state.field_inputan[data_level1];
  
        if (inputanLevel1) {
          const isArray = Array.isArray(inputanLevel1[0]);
  
          if (isArray) {
            const firstItem = inputanLevel1[0][0][0];
            const type = firstItem?.type;
  
            if (type === "nik") {
              detailStatus = {
                ...detailStatus,
                [data_level1]: { ...detailStatus[data_level1], 0: false },
              };
              manualStatus[data_level1] = { ...manualStatus[data_level1], 0: null };
            } else if (type === "perangkat") {
              detailStatus = {
                ...detailStatus,
                [data_level1]: { ...detailStatus[data_level1], 0: false },
              };
              manualStatus[data_level1] = { ...manualStatus[data_level1], 0: true };
            } else {
              detailStatus = {
                ...detailStatus,
                [data_level1]: { ...detailStatus[data_level1], 0: true },
              };
              manualStatus[data_level1] = { ...manualStatus[data_level1], 0: true };
            }
  
            allData[data_level1] = [[]];
            dinamisTemplate = { ...dinamisTemplate, [data_level1]: inputanLevel1[0] };
          } else {
            const firstItem = inputanLevel1[0];
            const type = firstItem?.type;
  
            if (type === "nik") {
              detailStatus = { ...detailStatus, [data_level1]: false };
              manualStatus[data_level1] = null;
            } else if (type === "perangkat") {
              detailStatus = { ...detailStatus, [data_level1]: false };
              manualStatus[data_level1] = true;
            } else {
              detailStatus = { ...detailStatus, [data_level1]: true };
              manualStatus[data_level1] = true;
            }
  
            allData[data_level1] = [];
            dinamisTemplate = { ...dinamisTemplate, [data_level1]: null };
          }
        }
      })
    );
  
    // Tambahkan dinamisTemplate tambahan
    dinamisTemplate = {
      ...dinamisTemplate,
      nik: this.state.frmNik,
    };
  
    if (this.props.location.state.jenis_layanan === "Internal") {
      dinamisTemplate = {
        ...dinamisTemplate,
        perangkat: this.state.frmListPerangkat,
      };
      allData["data_penandatangan"] = [
        { key: "uuid", value: "", pemohon: false },
        { key: "jabatan", value: "", pemohon: false },
        { key: "nama", value: "", pemohon: false },
        { key: "nip", value: "", pemohon: false },
        { key: "golongan", value: "", pemohon: false },
      ];
    }
  
    // Update state sekaligus
    await this.setState({
      status: {
        ...this.state.status,
        dataPenduduk: "none",
        dataPenduduk2: "none",
        form: true,
      },
      dt: allData,
      detailStatus,
      dinamisTemplate,
      manualStatus,
      nikStat: null,
      nik2Stat: null,
      status_data: "create",
      loadingPreview: false,
    });
  };
  
  // UBAH DATA SURAT
  // ubahData = id => {
  //   this.setState({ loadingPreview: true })
  //   this.setFieldInputan()

  //   let link_find = this.props.location.state.route_ws + "find"
  //   if(this.props.location.state.jenis_layanan === "Internal"){
  //     link_find = this.props.location.state.route_ws + "/find"
  //   }

  //   Get(link_find, id, data => {

  //     try {
  //       if (id && data.results.detail_surat) {
  //         // JSON Parse
  //         let detailParse = JSON.parse(data.results.detail_surat)

  //         let detailStatus = {}
  //         let dt = []
  //         let pemohonStatus = ''
  //         let field_inputan = []
  //         let formSelectPenduduk = {}
  //         let formSelect = {}
  //         let manualStatus = {}
  //         let dinamisTemplate = {}

  //         Object.keys(detailParse).map((dataParent, key) => {
  //           // #set awal
  //           dt[dataParent] = detailParse[dataParent]
  //           field_inputan[dataParent] = []
  //           formSelectPenduduk[dataParent] = {}
  //           // #set awal

  //           let tampungDataInternal = []
            
  //           detailParse[dataParent].map((dataChild, key_child) => {
  //             if(Array.isArray(dataChild)){
  //               // #set field inputan
  //               field_inputan[dataParent].push(this.state.field_inputan[dataParent][0])
  //               // #set dinamis template
  //               dinamisTemplate = {
  //                 ...dinamisTemplate,
  //                 [dataParent]: this.state.field_inputan[dataParent][0],
  //               }
  //               // #set form select penduduk
  //               formSelectPenduduk[dataParent][key_child] = this.state.formSelectPenduduk[dataParent][0]
                
  //               // #set form select perangkat
  //               if(this.props.location.state.jenis_layanan === "Internal"){

  //                 dataChild.map((dataChildSub, key_child_sub) => {

  //                   if(dataChildSub.key === "perangkat"){
  //                     tampungDataInternal[key_child] = this.state.formSelect[dataParent][0]
  //                   }
  //                 })
                  
  //                 formSelect[dataParent] = {...tampungDataInternal}

  //                 dinamisTemplate = {
  //                   ...dinamisTemplate,
  //                   perangkat: this.state.frmListPerangkat
  //                 }
  //               }
                
  //               // #set detail status
  //               detailStatus = {
  //                 ...detailStatus,
  //                 [dataParent]: {
  //                   ...detailStatus[dataParent],
  //                   [key_child]: true,
  //                 }
  //               }

  //               // #Set pemohon status
  //               dataChild.map((arrayChild, key_array_child) => {

  //                 if(arrayChild.pemohon === true){
  //                   pemohonStatus = dataParent+'&'+key_child
  //                 }

  //                 // #set manual status
  //                 if(key_array_child === 0 && arrayChild.key === 'nik'){
  //                   Get('penduduk/find', arrayChild.value.value, (data) => {
  //                     if(data.results){
  //                       manualStatus[dataParent] = {
  //                         ...manualStatus[dataParent],
  //                         [key_child]: null
  //                       }
  //                     }
  //                     else{
  //                       manualStatus[dataParent] = {
  //                         ...manualStatus[dataParent],
  //                         [key_child]: true
  //                       }
  //                     }
  //                   });
  //                 }
  //                 else{
  //                   manualStatus[dataParent] = {
  //                     ...manualStatus[dataParent],
  //                     [key_child]: true
  //                   }
  //                 }
  //               })
  //             }
  //             else{

  //               // #set manual status
  //               if(key_child === 0 && dataChild.key === 'nik'){
  //                 Get('penduduk/find', dataChild.value.value, (data) => {
  //                   if(data.results){
  //                     manualStatus[dataParent] = null
  //                   }
  //                   else{
  //                     manualStatus[dataParent] = true
  //                   }
  //                 });
  //               }
  //               else{
  //                 manualStatus[dataParent] = true
  //               }

  //               // #set field inputan
  //               field_inputan[dataParent] = this.state.field_inputan[dataParent]
  //               // #set dinamis template
  //               dinamisTemplate = {
  //                 ...dinamisTemplate,
  //                 [dataParent]: null,
  //               }
  //               // #set form select penduduk
  //               formSelectPenduduk[dataParent] = this.state.formSelectPenduduk[dataParent]
                
  //               // #set form select perangkat
  //               if(this.props.location.state.jenis_layanan === "Internal"){
  //                 formSelect[dataParent] = this.state.formSelect[dataParent]
  //               }

  //               // #set detail status
  //               detailStatus = {
  //                 ...detailStatus,
  //                 [dataParent]: true,
  //               }

  //               // #set pemohon status
  //               if(dataChild.pemohon === true){
  //                 pemohonStatus = dataParent
  //               }
  //             }
  //           })
        
  //           if(field_inputan[dataParent]){
  //             field_inputan[dataParent].map((dataField,key) => {
  
  //               if(Array.isArray(dataField)){
  //                 dataField[0].map((data2,key2) => {
                    
  //                   if(data2.type === "select"){
          
  //                     if(data2.option.length > 0){
  //                       let optionValue = []
            
  //                       data2.option.map((dtOption, key) => {
  //                         optionValue.push({ value: dtOption, label: dtOption });
  //                       })
            
  //                       formSelect= {
  //                         ...formSelect,
  //                           [data2.key]:optionValue
  //                       }
            
  //                     }
  //                     else{
  //                       let optionValue = []
            
  //                       optionValue = getList(data2.model,'')
                        
  //                       formSelect= {
  //                         ...formSelect,
  //                           [data2.key]:optionValue
  //                       }
  //                     }
  //                   }
  //                 })
  //               }
  //               else{
  //                 if(dataField.type === "select"){
  //                   if(dataField.option.length > 0){
  //                     let optionValue = []
          
  //                     dataField.option.map((dtOption, key) => {
  //                       optionValue.push({ value: dtOption, label: dtOption });
  //                     })
          
  //                     formSelect= {
  //                       ...formSelect,
  //                         [dataField.key]:optionValue
  //                     }
          
  //                   }
  //                   else{
  //                     let optionValue = []
          
  //                     optionValue = getList(dataField.model,'')
                      
  //                     formSelect= {
  //                       ...formSelect,
  //                         [dataField.key]:optionValue
  //                     }
  //                   }
  //                 }
  //               }
  //             })
  //           }
  //         })

  //         dt['uuid'] = data.results.uuid
  //         dt['id_jenis'] = data.results.id_jenis
  //         dt['pemohonStatus'] = pemohonStatus
          
  //         dinamisTemplate = {
  //           ...dinamisTemplate,
  //           nik: this.state.frmNik
  //         }

  //         let cek_validasi_pemohonStatus = false

  //         if(this.props.location.state.jenis_layanan === "Internal"){
  //           cek_validasi_pemohonStatus = true

  //           dt['data_pembuat'] = detailParse.data_pembuat
  //           dt['data_penandatangan'] = detailParse.data_penandatangan

  //           // #set penandatangan jika surat internal
  //           if(detailParse.data_penandatangan[0].value){

  //             let ttdSelected = this.state.listPerangkatDesa.map((x) => x.uuid === detailParse.data_penandatangan[0].value)

  //             let temp = this.state.listPerangkatDesa.map((x) => '0');

  //             let getTtdSelected = null
  //             ttdSelected.forEach((x, index) => {
  //               if (x) {
  //                 temp[index] = '1'
  //                 getTtdSelected = this.state.listPerangkatDesa[index]
  //               }
  //             })

  //             this.setState({ 
  //               accButtonPerangkatDesa: temp,
	// 			        ttdSelected: getTtdSelected,
  //             })
  //           }

  //           field_inputan['data_pembuat'] = [{
  //             key: '',
  //             value: '',
  //             pemohon: false,
  //           }]
            
  //           field_inputan['data_penandatangan'] = [
  //             {
  //               key: 'uuid',
  //               value: '',
  //               pemohon: false,
  //             },
  //             {
  //               key: 'jabatan',
  //               value: '',
  //               pemohon: false,
  //             },
  //             {
  //               key: 'nama',
  //               value: '',
  //               pemohon: false,
  //             },
  //             {
  //               key: 'nip',
  //               value: '',
  //               pemohon: false,
  //             },
  //             {
  //               key: 'golongan',
  //               value: '',
  //               pemohon: false,
  //             }
  //           ]
  //         }
  //         else{
  //           if(pemohonStatus){
  //             cek_validasi_pemohonStatus = true
  //           }
  //         }

  //         this.setState({
  //           manualStatus: manualStatus,
  //           dt: dt,
  //           detailStatus: detailStatus,
  //           field_inputan: field_inputan,
  //           dinamisTemplate: dinamisTemplate,
  //           formSelectPenduduk: formSelectPenduduk,
  //           formSelect: formSelect,
  //           pemohonStatus: pemohonStatus,
  //         })

  //         if(manualStatus &&
  //           dt &&
  //           detailStatus &&
  //           field_inputan &&
  //           dinamisTemplate &&
  //           formSelectPenduduk &&
  //           cek_validasi_pemohonStatus){
  //             setTimeout(function () {
  //               this.setState({
  //                 status: {
  //                   ...this.state.status,
  //                   form: true,
  //                 },
  //                 loadingPreview: false
  //               })
  //             }.bind(this),3000)
  //         }
  //         else{
  //           this.setState({
  //             loadingPreview: false,
  //             show: true,
  //             basicType: "warning",
  //             basicTitle: "Data Pengajuan Tidak Lengkap",
  //             pesanAlert: "Data pengajuan Tidak Dapat Diubah"
  //           });
  //         }
  //       }
  //       else{
  //         this.setState({
  //           loadingPreview: false,
  //           show: true,
  //           basicType: "warning",
  //           basicTitle: "Data Pengajuan Tidak Lengkap",
  //           pesanAlert: "Data pengajuan Tidak Dapat Diubah"
  //         });
  //       }
  //     } catch (e) {
  //       console.log('Error')
  //       console.log(e)
  //       this.setState({
  //         loadingPreview: false,
  //         show: true,
  //         basicType: "warning",
  //         basicTitle: "Data Pengajuan Tidak Lengkap",
  //         pesanAlert: "Data pengajuan Tidak Dapat Diubah"
  //       });
  //     }
  //   });
  // };
  ubahData = async (id) => {
    this.setState({ loadingPreview: true });
    this.setFieldInputan();

    let link_find = this.props.location.state.route_ws + "find";
    if (this.props.location.state.jenis_layanan === "Internal") {
        link_find = this.props.location.state.route_ws + "/find";
    }

    try {
        // let data = await Get(link_find, id, data);
        let data = await GetAwait(link_find, id); 

        if (id && data.data.results.detail_surat) {
            let detailParse = JSON.parse(data.data.results.detail_surat);

            let detailStatus = {};
            let dt = [];
            let pemohonStatus = '';
            let field_inputan = [];
            let formSelectPenduduk = {};
            let formSelect = {};
            let manualStatus = {};
            let dinamisTemplate = {};

            await Promise.all(Object.keys(detailParse).map(async (dataParent) => {
                dt[dataParent] = detailParse[dataParent];
                field_inputan[dataParent] = [];
                formSelectPenduduk[dataParent] = {};

                let tampungDataInternal = [];

                await Promise.all(detailParse[dataParent].map(async (dataChild, key_child) => {
                    if (Array.isArray(dataChild)) {
                        field_inputan[dataParent].push(this.state.field_inputan[dataParent][0]);
                        dinamisTemplate = {
                            ...dinamisTemplate,
                            [dataParent]: this.state.field_inputan[dataParent][0],
                        };
                        formSelectPenduduk[dataParent][key_child] = this.state.formSelectPenduduk[dataParent][0];

                        if (this.props.location.state.jenis_layanan === "Internal") {
                            await Promise.all(dataChild.map(async (dataChildSub) => {
                                if (dataChildSub.key === "perangkat") {
                                    tampungDataInternal[key_child] = this.state.formSelect[dataParent][0];
                                }
                            }));

                            formSelect[dataParent] = { ...tampungDataInternal };

                            dinamisTemplate = {
                                ...dinamisTemplate,
                                perangkat: this.state.frmListPerangkat,
                            };
                        }

                        detailStatus = {
                            ...detailStatus,
                            [dataParent]: {
                                ...detailStatus[dataParent],
                                [key_child]: true,
                            },
                        };

                        await Promise.all(dataChild.map(async (arrayChild, key_array_child) => {
                            if (arrayChild.pemohon === true) {
                                pemohonStatus = `${dataParent}&${key_child}`;
                            }

                            if (key_array_child === 0 && arrayChild.key === 'nik') {
                                // const pendudukData = await Get('penduduk/find', arrayChild.value.value);
                                const pendudukData = await GetAwait('penduduk/find', arrayChild.value.value);
                                manualStatus[dataParent] = {
                                    ...manualStatus[dataParent],
                                    [key_child]: pendudukData.data.results ? null : true,
                                };
                            } else {
                                manualStatus[dataParent] = {
                                    ...manualStatus[dataParent],
                                    [key_child]: true,
                                };
                            }
                        }));
                    } else {
                        if (key_child === 0 && dataChild.key === 'nik') {
                            // const pendudukData = await Get('penduduk/find', dataChild.value.value);
                            const pendudukData = await GetAwait('penduduk/find', dataChild.value.value);
                            manualStatus[dataParent] = pendudukData.data.results ? null : true;
                        } else {
                            manualStatus[dataParent] = true;
                        }

                        field_inputan[dataParent] = this.state.field_inputan[dataParent];
                        dinamisTemplate = {
                            ...dinamisTemplate,
                            [dataParent]: null,
                        };
                        formSelectPenduduk[dataParent] = this.state.formSelectPenduduk[dataParent];

                        if (this.props.location.state.jenis_layanan === "Internal") {
                            formSelect[dataParent] = this.state.formSelect[dataParent];
                        }

                        detailStatus = {
                            ...detailStatus,
                            [dataParent]: true,
                        };

                        if (dataChild.pemohon === true) {
                            pemohonStatus = dataParent;
                        }
                    }
                }));
            }));

            dt['uuid'] = data.data.results.uuid;
            dt['id_jenis'] = data.data.results.id_jenis;
            dt['pemohonStatus'] = pemohonStatus;

            dinamisTemplate = {
                ...dinamisTemplate,
                nik: this.state.frmNik,
            };

            let cek_validasi_pemohonStatus = false;

            if (this.props.location.state.jenis_layanan === "Internal") {
                cek_validasi_pemohonStatus = true;
                dt['data_pembuat'] = detailParse.data_pembuat;
                dt['data_penandatangan'] = detailParse.data_penandatangan;

                if (detailParse.data_penandatangan[0].value) {
                    let ttdSelected = this.state.listPerangkatDesa.find((x) => x.uuid === detailParse.data_penandatangan[0].value);

                    let temp = this.state.listPerangkatDesa.map(() => '0');

                    if (ttdSelected) {
                        let index = this.state.listPerangkatDesa.indexOf(ttdSelected);
                        temp[index] = '1';
                    }

                    this.setState({
                        accButtonPerangkatDesa: temp,
                        ttdSelected,
                    });
                }

                field_inputan['data_pembuat'] = [{ key: '', value: '', pemohon: false }];

                field_inputan['data_penandatangan'] = [
                    { key: 'uuid', value: '', pemohon: false },
                    { key: 'jabatan', value: '', pemohon: false },
                    { key: 'nama', value: '', pemohon: false },
                    { key: 'nip', value: '', pemohon: false },
                    { key: 'golongan', value: '', pemohon: false },
                ];
            } else {
                if (pemohonStatus) {
                    cek_validasi_pemohonStatus = true;
                }
            }

            if(this.isObjectEmpty(formSelect)){
              formSelect = this.state.formSelect
            }

            this.setState({
                manualStatus,
                dt,
                detailStatus,
                field_inputan,
                dinamisTemplate,
                formSelectPenduduk,
                formSelect,
                pemohonStatus,
            });

            if (
                manualStatus &&
                dt &&
                detailStatus &&
                field_inputan &&
                dinamisTemplate &&
                formSelectPenduduk &&
                cek_validasi_pemohonStatus
            ) {
                setTimeout(() => {
                    this.setState({
                        status: {
                            ...this.state.status,
                            form: true,
                        },
                        loadingPreview: false,
                    });
                }, 3000);
            } else {
                this.setState({
                    loadingPreview: false,
                    show: true,
                    basicType: "warning",
                    basicTitle: "Data Pengajuan Tidak Lengkap",
                    pesanAlert: "Data pengajuan Tidak Dapat Diubah",
                });
            }
        } else {
            this.setState({
                loadingPreview: false,
                show: true,
                basicType: "warning",
                basicTitle: "Data Pengajuan Tidak Lengkap",
                pesanAlert: "Data pengajuan Tidak Dapat Diubah",
            });
        }
    } catch (e) {
        console.error('Error:', e);
        this.setState({
            loadingPreview: false,
            show: true,
            basicType: "warning",
            basicTitle: "Data Pengajuan Tidak Lengkap",
            pesanAlert: "Data pengajuan Tidak Dapat Diubah",
        });
    }
  };

  // HAPUS DATA SURAT
  konfirmHapus = id => {
    this.setState({
      alert: (
        <SweetAlert
          showCancel
          confirmBtnText="Hapus"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="success"
          type="danger"
          title="Yakin ingin hapus data ?"
          onCancel={this.hideAlert}
          onConfirm={() => this.hapusData(id)}
        >
          Proses ini tidak dapat dibatalkan!
        </SweetAlert>
      )
    });
  };

  hapusData = id => {
    this.hideAlert();
    let psn = "Hapus";
    Delete(this.props.location.state.route_ws + "delete", id, res => {
      if (res === 200) {
        this.setState({
          show: true,
          basicType: "success",
          basicTitle: "Data "+this.props.location.state.nama_surat,
          pesanAlert: "Berhasil " + psn + " Data"
        });
      } else {
        this.setState({
          show: true,
          basicType: "danger",
          basicTitle: "Data "+this.props.location.state.nama_surat,
          pesanAlert: "Gagal " + psn + " Data"
        });
      }
      this.componentDidMount();
    });
  };

  // CARI DATA SURAT
  cariData = e => {
    if (e.key === 'Enter') {
      this.setState({ 
        dataCari:{
          ...this.state.dataCari,
          q: e.target.value,
        }, 
      });

      setTimeout(
        function() {
          this.fetch({ page: null, where: [] });
        }.bind(this),
        500
      );
    }
  }

// ################################################################################################

  // setFieldInputan() {
  //   let field_inputan = JSON.parse(this.props.location.state.field_inputan)
  //   console.log('field_inputan')
  //   console.log(field_inputan)

  //   let formSelect = {};
  //   let formSelectPenduduk = {};
  //   let manualStatus = {};
  //   let detailStatus = {};
  //   let pemohonStatus= {};

  //   Object.keys(field_inputan).forEach((data_level1) => {

  //     detailStatus = {
  //       ...detailStatus,
  //       [data_level1]: true,
  //     }
      
  //     formSelectPenduduk[data_level1] = {}
  //     manualStatus[data_level1] = null

  //     field_inputan[data_level1].map((data,key) => {

  //       if(Array.isArray(data)){
  //         field_inputan[data_level1] = [field_inputan[data_level1]]
          
  //         data.map((data2,key2) => {
  //           if(data2.type === "select"){

  //             if(data2.option.length > 0){
  //               let optionValue = []
    
  //               data2.option.map((dtOption, key) => {
  //                 optionValue.push({ value: dtOption, label: dtOption });
  //               })
    
  //               formSelect= {
  //                 ...formSelect,
  //                   [data2.key]:optionValue
  //               }
    
  //             }
  //             else{
  //               let optionValue = []
    
  //               optionValue = getList(data2.model,'')
                
  //               formSelect= {
  //                 ...formSelect,
  //                   [data2.key]:optionValue
  //               }
  //             }
  //           }
  //           else if(data2.type === "nik"){
  //             detailStatus = {
  //               ...detailStatus,
  //               [data_level1]: {
  //                 ...detailStatus[data_level1],
  //                 0: false,
  //               }
  //             }
    
  //             let optionValue = []
    
  //             optionValue = getList(data2.model,'')
    
  //             formSelectPenduduk[data_level1] = {
  //               ...formSelectPenduduk[data_level1],
  //               [key]:{
  //                 [data2.key]: optionValue,
  //               }
  //             }

  //             manualStatus[data_level1] = {
  //               ...manualStatus[data_level1],
  //               [key]: null
  //             }

  //             pemohonStatus = {
  //               ...pemohonStatus,
  //               [data_level1]: {
  //                 ...pemohonStatus[data_level1],
  //                 [key]: null,
  //               }
  //             }
  //           }
  //           else if(data2.type === "perangkat"){
  //             detailStatus = {
  //               ...detailStatus,
  //               [data_level1]: {
  //                 ...detailStatus[data_level1],
  //                 0: false,
  //               }
  //             }
    
  //             let optionValue = []
    
  //             optionValue = getList(data2.model,'')
    
  //             formSelect[data_level1] = {
  //               ...formSelect[data_level1],
  //               [key]:{
  //                 [data2.key]: optionValue,
  //               }
  //             }

  //             manualStatus[data_level1] = {
  //               ...manualStatus[data_level1],
  //               [key]: true
  //             }

  //             pemohonStatus = {
  //               ...pemohonStatus,
  //               [data_level1]: {
  //                 ...pemohonStatus[data_level1],
  //                 [key]: null,
  //               }
  //             }
  //           }

  //         })
  //       }
  //       else{
  //         if(data.type === "select"){

  //           if(data.option.length > 0){
  //             let optionValue = []

  //             data.option.map((dtOption, key) => {
  //               optionValue.push({ value: dtOption, label: dtOption });
  //             })

  //             formSelect= {
  //               ...formSelect,
  //                 [data.key]:optionValue
  //             }

  //           }
  //           else{
  //             let optionValue = []

  //             optionValue = getList(data.model,'')
              
  //             formSelect= {
  //               ...formSelect,
  //                 [data.key]:optionValue
  //             }
  //           }
  //         }
  //         else if(data.type === "nik"){
  //           detailStatus = {
  //             ...detailStatus,
  //             [data_level1]: false,
  //           }

  //           let optionValue = []

  //           optionValue = getList(data.model,'')

  //           formSelectPenduduk[data_level1] = {
  //             ...formSelectPenduduk[data_level1],
  //             [data.key]: optionValue,
  //           }

  //           manualStatus[data_level1] = null

  //           pemohonStatus = {
  //             ...pemohonStatus,
  //             [data_level1]: null,
  //           }
  //         }
  //         else if(data.type === "perangkat"){
  //           detailStatus = {
  //             ...detailStatus,
  //             [data_level1]: false,
  //           }

  //           let optionValue = []

  //           optionValue = getList(data.model,'')

  //           formSelect[data_level1] = {
  //             ...formSelect[data_level1],
  //             [data.key]: optionValue,
  //           }

  //           manualStatus[data_level1] = true

  //           pemohonStatus = {
  //             ...pemohonStatus,
  //             [data_level1]: null,
  //           }
  //         }
  //       }
  //     })
      
  //     this.setState({
  //       field_inputan: field_inputan,
  //       detailStatus: detailStatus,
  //       formSelect: formSelect,
  //       formSelectPenduduk: formSelectPenduduk,
  //       manualStatus: manualStatus,
  //       pemohonStatus: pemohonStatus,
  //     })

  //   })

  // }

  async setFieldInputan() {
    let field_inputan = JSON.parse(this.props.location.state.field_inputan);

    console.log('cek fielldnya')
    console.log(field_inputan)
    let formSelect = {};
    let formSelectPenduduk = {};
    let manualStatus = {};
    let detailStatus = {};
    let pemohonStatus = {};

    await Promise.all(Object.keys(field_inputan).map(async (data_level1) => {
      detailStatus = {
        ...detailStatus,
        [data_level1]: true,
      };

      formSelectPenduduk[data_level1] = {};
      manualStatus[data_level1] = null;

      await Promise.all(field_inputan[data_level1].map(async (data, key) => {
        if (Array.isArray(data)) {
          field_inputan[data_level1] = [field_inputan[data_level1]];

          await Promise.all(data.map(async (data2, key2) => {

            if (data2.type === "select") {
              if (data2.option.length > 0) {
                const optionValue = data2.option.map(dtOption => ({ value: dtOption, label: dtOption }));

                formSelect = {
                  ...formSelect,
                  [data2.key]: optionValue,
                };
              } else {
                const optionValue = getList(data2.model, '');

                formSelect = {
                  ...formSelect,
                  [data2.key]: optionValue,
                };

              }
            } else if (data2.type === "nik") {
              detailStatus = {
                ...detailStatus,
                [data_level1]: {
                  ...detailStatus[data_level1],
                  0: false,
                },
              };

              // const optionValue = getList(data2.model, '');
              const optionValue = this.state.frmNik;

              formSelectPenduduk[data_level1] = {
                ...formSelectPenduduk[data_level1],
                [key]: {
                  [data2.key]: optionValue,
                },
              };

              manualStatus[data_level1] = {
                ...manualStatus[data_level1],
                [key]: null,
              };

              pemohonStatus = {
                ...pemohonStatus,
                [data_level1]: {
                  ...pemohonStatus[data_level1],
                  [key]: null,
                },
              };
            } else if (data2.type === "perangkat") {
              detailStatus = {
                ...detailStatus,
                [data_level1]: {
                  ...detailStatus[data_level1],
                  0: false,
                },
              };

              const optionValue = getList(data2.model, '');

              formSelect[data_level1] = {
                ...formSelect[data_level1],
                [key]: {
                  [data2.key]: optionValue,
                },
              };

              manualStatus[data_level1] = {
                ...manualStatus[data_level1],
                [key]: true,
              };

              pemohonStatus = {
                ...pemohonStatus,
                [data_level1]: {
                  ...pemohonStatus[data_level1],
                  [key]: null,
                },
              };
            }
          }));
        } else {
          if (data.type === "select") {

            if (data.option.length > 0) {
              const optionValue = data.option.map(dtOption => ({ value: dtOption, label: dtOption }));

              formSelect = {
                ...formSelect,
                [data.key]: optionValue,
              };
            } else {
              const optionValue = getList(data.model, '');
              
              formSelect = {
                ...formSelect,
                [data.key]: optionValue,
              };

            }
          } else if (data.type === "nik") {
            detailStatus = {
              ...detailStatus,
              [data_level1]: false,
            };

            // const optionValue = getList(data.model, '');
            const optionValue = this.state.frmNik;

            formSelectPenduduk[data_level1] = {
              ...formSelectPenduduk[data_level1],
              [data.key]: optionValue,
            };

            manualStatus[data_level1] = null;

            pemohonStatus = {
              ...pemohonStatus,
              [data_level1]: null,
            };
          } else if (data.type === "perangkat") {
            detailStatus = {
              ...detailStatus,
              [data_level1]: false,
            };

            const optionValue = getList(data.model, '');

            formSelect[data_level1] = {
              ...formSelect[data_level1],
              [data.key]: optionValue,
            };

            manualStatus[data_level1] = true;

            pemohonStatus = {
              ...pemohonStatus,
              [data_level1]: null,
            };
          }
        }
      }));

      this.setState({
        field_inputan,
        detailStatus,
        formSelect: formSelect,
        formSelectPenduduk,
        manualStatus,
        pemohonStatus,
      });
    }));
  }

  componentDidMount() {
    if (this.props.location.state) {
      this.fetch({ page: null, where: [] });
      this.setFieldInputan();
      
      let set_jenis = this.props.location.state.route_surat.substring(1);

      this.setState({
        get_jenis_surat: set_jenis,
      })

      Get("penduduk", null, data => {
        let frmNik = [];
        let frmNik2 = [];
        let tmplistPenduduk = {}
        let tmplistPenduduk2 = {}
        data.results.data.forEach(dt => {
          frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
          tmplistPenduduk = {
            ...tmplistPenduduk,
            [dt.id]: dt
          }
          frmNik2.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
          tmplistPenduduk2 = {
            ...tmplistPenduduk2,
            [dt.id]: dt
          }
        });
        this.setState({ frmNik, frmNik2, tmplistPenduduk, tmplistPenduduk2 });

        // For testing
        if (this.props.getListNIK) {
          this.props.getListNIK(frmNik)
        }
      });
        
      Get('shdk/list', null, (data) => {
        let frmShdkLabel = [];
        data.results.forEach(dt => {
          frmShdkLabel.push({ value: dt.nama, label: dt.nama });
        });
        this.setState({ frmShdkLabel });
      });

      if(this.props.location.state.jenis_layanan === "Internal"){
        // Get list perangkat
        Get("perangkat/list", null, data => {
          let frmListPerangkat = [];
          data.results.forEach(dt => {
            frmListPerangkat.push({ value: dt.uuid, label: dt.data_penduduk.nama + ' (' + dt.data_jabatan.nama + ')' });
          });
          this.setState({ frmListPerangkat });
        });
        // Get list ttd
        Get('tanda-tangan/list', null, (data) => {
          if (data.results) {
            let statUuidPerangkatDesa = null
    
            this.setState({ listPerangkatDesa: data.results });
            
            data.results.forEach((dt, i) => {
              if (dt.aktif === "1") {
                this.setState({ ttdSelected: dt });
                statUuidPerangkatDesa = dt.uuid
              }
            });
    
            let listTtd = data.results.map((x) => x.aktif)
    
            // Jika tidak ada ttd utama, maka set perangkat pertama sbg dipilih
            if (statUuidPerangkatDesa === null) {
              if (data.results.length > 0) {
                let temp = listTtd.map((x) => '0');
                temp[0] = '1';
                this.setState({ 
                  accButtonPerangkatDesa: temp,
                  ttdSelected: data.results[0]
                })
              }
            } else {
              this.setState({accButtonPerangkatDesa: listTtd})
            }
            this.forceUpdate();
          }
        });

      }
    } else {
      this.setState({ redirect: true });
    }
  }

  // cek redirect jika state kosong
  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
  };

  isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  render() {
    // console.log('data render')
    // console.log(this.props.location.state)
    // console.log(this.state.field_inputan)
    var data = this.state.data;
    
    let no = 0;

    let columns= []
    // const { SearchBar } = Search;
    if(this.props.location.state && this.props.location.state.jenis_layanan === "Internal"){
      columns = [
        {
            dataField: "no",
            text: "No",
            isDummyField: true,
            csvExport: false,
            headerAlign: 'center',
            align: 'center',
            formatter: (key, obj, index) =>{          
                let current_pagenum = this.state.pagination.current_page;
                let total_records_per_page = this.state.pagination.per_page;
                let row_index = (index+1);
                let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
                return serial_num; 
            }
        },
        {
          dataField: "tanggal_surat",
          headerAlign: 'center',
          align: 'center',
          text: "Tanggal",
          formatter: (cell, obj) => {
            let plainTime = '-'
            if (obj.created_at) {
              let date = new Date(obj.created_at)
              date = date.toLocaleString('id-ID')
              
              const datetime = date.split(' ')
              
    
              date = datetime[0]
              let time = datetime[1]
    
              const splitDate = date.split('/')
              time = time.replaceAll('.', ':')
    
              const list_bulan = [
                'Januari',
                'Februari',
                'Maret',
                'April',
                'Mei',
                'Juni',
                'Juli',
                'Agustus',
                'September',
                'Oktober',
                'November',
                'Desember'
              ];
  
              plainTime = `${splitDate[0]} ${list_bulan[parseInt(splitDate[1]) - 1]} ${splitDate[2]}  ${time}`;
            }
  
            return plainTime
          },
          isDummyField: true,
          sort: true
        },
        {
          dataField: "nomor",
          headerAlign: 'center',
          align: 'center',
          text: "Nomor surat",
          formatter: (cell, obj) => {
            return obj.nomor === "" ? "-" : obj.nomor;
          },
          sort: true
        },
        {
          dataField: "nama_pegawai",
          headerAlign: 'center',
          align: 'center',
          text: "Nama Pegawai",
          formatter: (cell, obj) => {
            const detail_surat = JSON.parse(obj.detail_surat)

            let tampil = '-'
            if(detail_surat.data_perangkat){
              if(Array.isArray(detail_surat.data_perangkat[0])){
                if(detail_surat.data_perangkat && detail_surat.data_perangkat[0] && detail_surat.data_perangkat[0][1] && detail_surat.data_perangkat[0][1].value){
                  tampil = detail_surat.data_perangkat[0][1].value
                }
              }
              else{
                tampil = detail_surat.data_perangkat[1].value
              }
            }
  
            return tampil;
          },
          isDummyField: true,
          sort: true
        },
        {
          dataField: "jenis_ttd",
          headerAlign: 'center',
          align: 'center',
          text: "Dikeluarkan Oleh",
          formatter: (cell, obj) => {
            return <span style={{ textTransform: 'capitalize' }}>{obj.jenis_ttd}</span>
            // return <span style={{ textTransform: 'capitalize' }}>{obj.jenis_ttd && obj.jenis_ttd.toLowerCase() === "internal"?"Desa":"Kecamatan"}</span>
          }
        },
        {
          dataField: "status_surat",
          headerAlign: 'center',
          align: 'center',
          text: "Status",
        },
        {
          dataField: "aksi",
          headerAlign: 'center',
          align: 'center',
          text: "Aksi",
          isDummyField: true,
          csvExport: false,
          formatter: this.tombolAksi
        }
      ];
    }
    else{
      columns = [
        {
            dataField: "no",
            text: "No",
            isDummyField: true,
            csvExport: false,
            headerAlign: 'center',
            align: 'center',
            formatter: (key, obj, index) =>{          
                let current_pagenum = this.state.pagination.current_page;
                let total_records_per_page = this.state.pagination.per_page;
                let row_index = (index+1);
                let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
                return serial_num; 
            }
        },
        {
          dataField: "tanggal_surat",
          headerAlign: 'center',
          align: 'center',
          text: "Tanggal",
          formatter: (cell, obj) => {
            let plainTime = '-'
            if (obj.created_at) {
              let date = new Date(obj.created_at)
              date = date.toLocaleString('id-ID')
              
              const datetime = date.split(' ')
              
    
              date = datetime[0]
              let time = datetime[1]
    
              const splitDate = date.split('/')
              time = time.replaceAll('.', ':')
    
              const list_bulan = [
                'Januari',
                'Februari',
                'Maret',
                'April',
                'Mei',
                'Juni',
                'Juli',
                'Agustus',
                'September',
                'Oktober',
                'November',
                'Desember'
              ];
  
              plainTime = `${splitDate[0]} ${list_bulan[parseInt(splitDate[1]) - 1]} ${splitDate[2]}  ${time}`;
            }
  
            return plainTime
          },
          isDummyField: true,
          sort: true
        },
        {
          dataField: "kode_surat",
          headerAlign: 'center',
          align: 'center',
          text: "Kode Pengajuan",
          formatter: (cell, obj) => {
            return obj.kode_surat === "" || obj.kode_surat === null ? "-" : obj.kode_surat;
          },
          sort: true
        },
        {
          dataField: "nomor",
          headerAlign: 'center',
          align: 'center',
          text: "Nomor surat",
          formatter: (cell, obj) => {
            return obj.nomor === "" ? "-" : obj.nomor;
          },
          sort: true
        },
        {
          dataField: "nik",
          headerAlign: 'center',
          align: 'center',
          text: "NIK",
          sort: true
        },
        {
          dataField: "nama_pemohon",
          headerAlign: 'center',
          align: 'center',
          text: "Nama",
          sort: true
        },
        {
          dataField: "status",
          headerAlign: 'center',
          align: 'center',
          text: "Status",
          isDummyField: true,
          formatter: (cell, obj) => {
            let status = "-";
            obj.data_status.forEach(dt => {
              status = dt.status;
            });
            
            if(status === 'Selesai Mobile'){
              status = "Disetujui";
            }
  
            return status;
          },
          sort: true
        },
        {
          dataField: "aksi",
          headerAlign: 'center',
          align: 'center',
          text: "Aksi",
          isDummyField: true,
          csvExport: false,
          formatter: this.tombolAksi
        }
      ];
    }

    return (
      <div data-testid="page-surat keterangan domisili">
        {this.renderRedirect()}
        <SweetAlert
          show={this.state.show}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="info"
          onCancel={this.closeAlert}
          showConfirm={false}
        >
          {this.state.pesanAlert}
          {this.state.successAlert ? (
            <div>
              <br />
              <Button
                color="success"
                className="mr-2"
                onClick={() => {
                  this.closeAlert();
                  this.tambahData();
                }}
              >
                Tambah Data
              </Button>

              {/* {
                this.props.location.state.jenis_layanan === "Internal"
                ? 
                  <Button
                    color="warning"
                    className="btn-icon mr-2"
                    onClick={() => {
                      this.closeAlert();
                      this.ubahData(this.state.get_data_surat.uuid_surat)
                    }}
                  >
                    <span style={{ color: "black" }}>Ubah Data</span>
                  </Button>
                : */}
                  <Button
                    className="btn btn-secondary-custom"
                  >
                    <Link
                      data-testid="btn-eksekusi_surat"
                      onClick={() => {
                        // For testing
                        if (this.props.clickEksekusiSurat) {
                          this.props.clickEksekusiSurat()
                        }
                      }}
                      to={{
                        pathname: process.env.PUBLIC_URL + "/admin/disposisi",
                        tabProps: "2"
                      }}
                    >
                      <span style={{ color: "white" }}>Eksekusi Surat</span>
                    </Link>
                  </Button>
              {/* } */}
            </div>
          ) : (
            ""
          )}
        </SweetAlert>

        {this.state.alert}

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card mb-0">
                <div className="card-header">
                  <div className="row card-body datatable-react">
                    {
                      this.state.loading 
                      ?
                      <></>
                      :
                      <>
                        <div className="col-sm-6">
                          <input
                            type="text"
                            className="form-control"
                            id="cariTable"
                            placeholder="Cari berdasarkan kode pengajuan atau nik pemohon atau nomor surat"
                            onKeyPress={this.cariData}
                          />
                        </div>
                        <div className="col-sm-6 text-right">
                          <Button
                            data-testid="tblCreateSuratDomisili"
                            size="sm"
                            color="success"
                            // className="btn-square"
                            onClick={() => {
                              this.tambahData()
                            }}
                          >
                            Tambah Data
                          </Button>
                        </div>
                      </>
                    }
                    <div className="col-sm-12">
                      {this.state.loading ? (
                        <div className="row">
                          <div className="col-sm-12" align="center">
                            <img 
                            alt="loading"
                            src={require("../../assets/images/tes-loading.gif")} 
                            style={{
                              borderRadius: "10px",
                              width: '100px'
                            }}/> 
                          </div>
                        </div>
                      ) : (
                        <>
                          <BootstrapTable keyField="id" data={data} columns={columns} />
                          <div className="pull-right text-white">
                            {this.state.awal}
                            {this.state.sebelum}
                            {this.state.hal.map(dt => {
                              return dt;
                            })}
                            {this.state.setelah}
                            {this.state.akhir}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        {/* Loading preview */}
        <SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>

        <ModalGenerateForm
          data={this.state.dt}
          isOpen={this.state.status.form}
          propsData={this.props}
          kiosk={false}
          fieldInputan={this.state.field_inputan}
          statusData={this.state.status_data}
          optionData={{
            detailStatus: this.state.detailStatus,
            dinamisTemplate: this.state.dinamisTemplate,
            formSelect: this.state.formSelect,
            formSelectPenduduk: this.state.formSelectPenduduk,
            frmListPerangkat: this.state.frmListPerangkat,
            manualStatus: this.state.manualStatus,
            pemohonStatus: this.state.pemohonStatus,
            accButtonPerangkatDesa: this.state.accButtonPerangkatDesa,
            listPerangkatDesa: this.state.listPerangkatDesa,
            ttdSelected: this.state.ttdSelected,
            status: this.state.status,
            dataSurat: this.props.location.state,
          }}
          setAlert={(e) => {
            this.setState(e)
          }}
          setStatusRefresh={(e) => {
            if (e) {
              this.fetch({ page: null, where: [] });
            }
          }}
          setIsOpen={(e) => {
            if (!e) {
              this.setState({ dt: null })
            }
            this.setState({
              status: {
                ...this.state.status,
                form: e,
                frmDetailPengajuan: false,
              }
            })
          }}
        />
        
				{/* Modal Preview Draft Surat */}
				<Modal
					classNames={{ overlay: 'custom-map-modal' }}
					open={this.state.status.frmPreviewDraft}
					onClose={() => {
						// this.setState({
						// 	status:{
						// 		...this.state.status,
						// 		modalKonfirmasi: true,
						// 		frmPreviewDraft: false,
						// 	}
						// })
					}}
					styles={{ 
						modal: {
							width: '100%',
							height: '100%',
							maxHeight: 'unset',
							maxWidth: 'unset',
						  }
					}}
					closeOnEsc={false}
					closeOnOverlayClick={false}
				>
					<div
						className="modal-body"
						style={{
							display: 'flex',
							justifyContent: 'center',
							flexDirection: 'column',
							height: '90%',
							alignItems: 'center'
						}}
					>
							<center>
								<span><h4><b>Berikut adalah draft surat yang telah anda ajukan,<br/> silahkan cek kelengkapan data anda sebelum melanjutkan!</b></h4></span><br/>
							</center>

							<Iframe 
								id="myFrame" 
								src={
									API_URL +
									// 'cetak-surat/' +
									this.state.get_jenis_surat +
									// '/' +
									this.state.get_data_surat.uuid_surat +
									'?show=Ya&status_preview=ya#toolbar=0'
								}
								// styles={
								// 	{display: 'none'}
								// }
								onLoad={(e) => {
									this.setState({
										loadingPreview: false
									})
								}}
								width="100%"
								height="100%"
								className="myClassname"
								display={this.state.loadingPreview ? "none" : "block"}
								position="relative"
							/>
						{/* </div> */}
					</div>
					<div
						className="modal-footer"
						style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
					>
						<button
							onClick={() => {
                this.setState({
									status:{
                    ...this.state.status,
                    frmPreviewDraft: false,
                  },
                  status_data:'update',
								})
								this.ubahData(this.state.get_data_surat.uuid_surat)
							}}
							className="btn btn-warning"
						>
							Ubah Data Pengajuan
						</button>
						<button
							onClick={() => {
                this.setState({
                  status:{
                    ...this.state.status,
                    frmPreviewDraft: false,
                  },
                  showBio: false,
                  show: true,
                  basicType: "success",
                  basicTitle: "Data "+this.props.location.state.nama_surat,
                  pesanAlert: "Berhasil "+ this.state.status.jenis_form +" Data",
                  successAlert: true
                });
							}}
							className="btn btn-success"
						>
							Lanjutkan Pengajuan
						</button>
					</div>
				</Modal>
				{/* End Modal Preview Draft Surat */}
        
      </div>
    );
  }
}

export default BasicTable;
